import { createFileRoute } from "@tanstack/react-router";

import { AiUsage } from "../features/admin/AiUsage";
import { useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/admin/ai-usage")({
  component: TabRoute,
});

function TabRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <AiUsage key={me.data.user.id} me={me.data} />;
}
